import React from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import styled, { injectGlobal } from 'styled-components';
import { PageWrapper, fonts, fontSizes, mediaQueries, spacing, colors } from '../components/Styling';

const FooterLink = styled(Link)`
  color: ${colors.black};
  font-family: ${fonts.sans};
  font-size: ${fontSizes[1]};
  flex: 1 1 100%;
  opacity: 0.35;
  text-decoration: none;
  transition: opacity 0.2s, color 0.2s;
  text-align: center;
  margin-bottom: ${spacing[4]};

  ${mediaQueries.medium`
    flex: 1 1 auto;
    margin-bottom: initial;
  `};

  &:hover {
    color: ${props => props.color ? props.color : colors.black};
    opacity: 1;
  }
`;

const ExternalLink = FooterLink.withComponent('a');

const StyledFooter = styled.footer`
  align-items: center;
  background-color: white;
  bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: ${spacing[5]};
  margin-left: calc(-${spacing[2]} - 3vw - 1px);
  padding: calc(1rem + 3vw);
  width: calc(100% + ${spacing[2]} * 2 + 6vw + 2px);

  ${mediaQueries.medium`
    margin-top: ${spacing[6]};
    margin-left: calc(-${spacing[6]} - 1px);
    width: calc(100% + ${spacing[6]} * 2 + 2px);
  `};

  ${mediaQueries.large`
    margin-top: ${spacing[7]};
    `};
`;

export class Footer extends React.Component {
  render() {
    return (
      <StyledFooter>
        <FooterLink to="/impressum">
          <span>Impressum</span>
        </FooterLink>
        <FooterLink to="/partners">
          <span>Partners</span>
        </FooterLink>
        <ExternalLink color="#3b5998" href={'https://' + this.props.facebook}>
          <span>Facebook</span>
        </ExternalLink>
        <ExternalLink color="#ff7700" href={'https://' + this.props.soundcloud}>
          <span>SoundCloud</span>
        </ExternalLink>
      </StyledFooter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js